<template>
  <!-- container -->
  <div class="container mb-4 p-sm-3 col-md-8">
    <h1>
      お問い合わせ
    </h1>
    <p>
      <span class="attention">※</span>必須
    </p>
    <form class="mb-5" method="post" @submit.prevent="submit()">
      <div class="p-3">
        <p>講師番号</p>
        <p class="font-weight-bold">{{ prof.lecturer_no }}</p>
      </div>
      <div class="p-3">
        <p>講師名</p>
        <p class="font-weight-bold">{{ prof.name }}</p>
      </div>
      <div class="p-3">
        <p>メールアドレス</p>
        <p class="font-weight-bold">{{ prof.email }}</p>
      </div>
      <div class="form-group p-3">
        <label for="Kind">協会への連絡種別</label>
        <select class="form-control" id="" v-model="inquiry_type" ref="inquiryType">
          <option value="">選んで下さい...</option>
          <option>事務局への報告・意見・依頼書</option>
          <option>講師用一般の問合せ</option>
        </select>
      </div>
      <div class="form-group p-3">
        <label for="inquiryContent">
          内容<span class="attention">※</span>
        </label>
        <textarea class="form-control" id="inquiryContent" aria-required="true" required placeholder="お問合せ内容" rows="10" v-model="inquiry" ref="inquiry"></textarea>
      </div>
      <div class="btn-group" role="group" aria-label="group">
        <button type="submit" class="btn btn-primary btn-lg text-white" :disabled="isSubmitDisabled" ref="submit">送信する</button>
      </div>
    </form>
    <p class="text-right mt-5">
      <router-link to="/mypage">マイページへのリンク</router-link>
    </p>
  </div>
</template>

<script>
import api from 'api'
import modal from 'util/modal'
export default {
  data () {
    return {
      prof: '',
      inquiry_type: '',
      inquiry: '',
      isDisabled: false
    }
  },
  created () {
    api.fetchLecturerProfile(this)
    .then(prof => { this.prof = prof })
    .catch(err => {
      if (err.status === 401) {
        api.onAuthRequired(this)
      } else {
        modal.showErrorModal(this, err)
      }
    })
  },
  methods: {
    submit () {
      if (this.isSubmitDisabled) { return }
      this.isDisabled = true
      let obj = {
        inquiry_type: this.inquiry_type,
        inquiry: this.inquiry
      }
      api.sendInquiry(this, obj).then(_ =>
        this.$router.push('/mypage'))
      .catch(err => {
        if (err.status === 401) {
          modal.showLoginModal(this)
        } else {
          modal.showErrorModal(this, err)
        }
        this.isDisabled = false
      })
    }
  },
  computed: {
    isSubmitDisabled () {
      return !this.inquiry_type || !this.inquiry || this.isDisabled
    }
  }
}
</script>



// WEBPACK FOOTER //
// Inquiry.vue?c8759430